<div class="kendo-textarea" [formGroup]="parentForm">
    <kendo-formfield>
        <kendo-floatinglabel text="{{inputText}}" class="{{autofillValue.length > 0 ? 'k-focus' : ''}}">
            <kendo-textarea
                [style.width.px]="200"
                [style.min-height.px]="120"
                resizable="auto"
                [maxlength]="maxLength"
                [value]="autofillValue"
                [formControlName]="formControlName"
                (valueChange)="onChange($event)"
                [readonly]="isReadOnly"
                [disabled]="isReadOnly"
                class="{{autofillValue.length > 0 ? 'k-focus' : ''}}"
            >
                <!-- <kendo-textarea-suffix class="custom-styling">
                    <span class="counter">{{ counter }}</span>
                </kendo-textarea-suffix> -->
            </kendo-textarea>
        </kendo-floatinglabel>
    </kendo-formfield>
  </div>